import { PayToDataDTO } from './../dto/remittance/remittance.dto';
import { ProfileServices } from './../services/profile/profile.service';
import { RemittanceService } from './../services/remittance/remittance.service';
import { MasterDataProviderServices } from './../services/masterdata/masterdata-provider.service';
import { ServiceChargeService } from './../services/administation/service-charge.service';
import { CustomerBranchService } from './../services/profile/branch.service';
import { RateManagementServices } from './../services/administation/rate-management.service';
import { CustomerBeneficieriesService } from './../services/beneficiery/beneficiery';
import { Injectable } from '@angular/core';
import {
  CommonResponseDTO,
  TransformApiResponseDTO,
} from '../dto/api/api-response.dto';
import {
  AddBeneficieryDTO,
  InquiryAddBeneficieryDTO,
} from '../dto/account/beneficieries';
import {
  CustomerConfirmationTransferPayloadDTO,
  InquiryPaymentDigitalDTO,
  RemittancePayloadDTO,
  RemittancePrePaidDTO,
} from '../dto/remittance/remittance.dto';
import { UpdateProfileDTO } from '../dto/account/profile.dto';
import { MasterDataBankServices } from '../services/administation/masterdata-bank.service';
import { MasterDataProductServices } from '../services/administation/masterdata-product.service';
import { DataCustomerService } from '../services/administation/data-customer.service';
import { BranchManagementServices } from '../services/branch/branch-management.service';
import { MasterDataRegionServices } from '../services/masterdata/masterdata-region.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerBloc {
  constructor(
    private customerBeneficieriesService: CustomerBeneficieriesService,
    private readonly rateManagementServices: RateManagementServices,
    private readonly customerBranchService: CustomerBranchService,
    private readonly serviceChargeService: ServiceChargeService,
    private readonly masterDataProviderServices: MasterDataProviderServices,
    private readonly masterDataBankServices: MasterDataBankServices,
    private readonly masterDataProductServices: MasterDataProductServices,
    private readonly remittanceService: RemittanceService,
    private readonly dataCustomerService: DataCustomerService,
    private readonly branchManagementServices: BranchManagementServices,
    private readonly profileServices: ProfileServices,
    private readonly masterDataRegionServices: MasterDataRegionServices
  ) {}

  async getIdentityImage(): Promise<any> {
    return new Promise(async (resolve) => {
      this.dataCustomerService.getHasIdentityImage().subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getIdentitySelfieImage(): Promise<any> {
    return new Promise(async (resolve) => {
      this.dataCustomerService.getHasIdentitySelfieImage().subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getIdentitySelfieBackImage(): Promise<any> {
    return new Promise(async (resolve) => {
      this.dataCustomerService.getHasIdentitySelfieBackImage().subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async updateCustomerProfile(
    dataProfile: UpdateProfileDTO
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.profileServices.submitProfile(dataProfile).subscribe(
        (result) => {
          const returnData = {
            error: false,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            error: true,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  async getInternalBranch(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.customerBranchService.getInternalBranch(param).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCustomerBeneficiery(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.customerBeneficieriesService.getBeneficieries(param).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getBaseCurrency(): Promise<any> {
    return new Promise(async (resolve) => {
      this.rateManagementServices.getBaseCurrenciesSelect(null).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCustomerRate(param): Promise<any> {
    return new Promise(async (resolve) => {
      this.rateManagementServices.getRatesCustomer(param).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getServiceCharge(param): Promise<any> {
    return new Promise(async (resolve) => {
      this.serviceChargeService.getCustomerServiceCharge(param).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCustomerMainProvider(): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataProviderServices.getCustomerMainProvider(null).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCustomerBank(): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataBankServices.getBankSelect(null, 'customer').subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getPaydiaBank(): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataBankServices.getBankPaydiaSelect(null).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getProductCategory(): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataProductServices.getProductCategory(null).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCustomerProduct(param): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataProductServices.getCustomerProduct(param).subscribe(
        (data) => {
          resolve(data.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async submitInquiryPaymentDigital(
    payload: InquiryPaymentDigitalDTO
  ): Promise<CommonResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.addInquiryPaymentDigital(payload).subscribe(
        async (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async submitRemittance(
    payload: RemittancePayloadDTO
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.addRemittance(payload, true).subscribe(
        async (result) => {
          const returnData = {
            data: result.data,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            data: null,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  async submitPaymentDigital(
    payload: RemittancePrePaidDTO
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.addRemittanceBpjs(payload, true).subscribe(
        async (result) => {
          const returnData = {
            data: result.data,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            data: null,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  getTransactQRDetail(
    remittanceUuid: string
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService
        .getRemmitanceCustomerDetail(remittanceUuid)
        .subscribe(
          async (result) => {
            const returnData = {
              error: false,
              data: result,
              message: 'success',
            };
            resolve(returnData);
          },
          (error) => {
            const returnData = {
              error: true,
              data: null,
              message: error.message,
            };
            resolve(returnData);
          }
        );
    });
  }

  getTransactionDetail(
    remittanceUuid: string
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.getRemmitanceDetail(remittanceUuid).subscribe(
        async (result) => {
          const returnData = {
            error: false,
            data: result.data,
            message: '',
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            error: true,
            data: null,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  getTransactionRemittanceHistory(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.remittanceService.getRemmitanceListPagination(param).subscribe(
        async (result) => {
          resolve(result);
        },
        (error) => {
          resolve(error);
        }
      );
    });
  }

  getRemittancePendingTransaction(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.remittanceService.getRemittancePendingTransaction(param).subscribe(
        async (result) => {
          resolve(result);
        },
        (error) => {
          resolve(error);
        }
      );
    });
  }

  getBranchDetail(uuid: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.branchManagementServices.getDetailBranch(uuid).subscribe(
        async (result) => {
          resolve(result?.data);
        },
        (error) => {
          resolve(error);
        }
      );
    });
  }

  async submitInquiryAddBeneficiery(
    payload: InquiryAddBeneficieryDTO
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.addBeneficieryInquiry(payload).subscribe(
        async (result) => {
          const returnData = {
            data: result.data,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            data: null,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  async submitAddBeneficiery(
    payload: AddBeneficieryDTO
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.customerBeneficieriesService.addBeneficieries(payload).subscribe(
        async (result) => {
          const returnData = {
            error: false,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            error: true,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  async getCustomerTransferDetail(param: any): Promise<CommonResponseDTO> {
    return new Promise(async (resolve) => {
      this.remittanceService.checkConfirmationTransfer(param).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async submitEditBeneficiery(
    payload: AddBeneficieryDTO,
    uuid: string
  ): Promise<any> {
    return new Promise(async (resolve) => {
      this.customerBeneficieriesService
        .updateBeneficieries(payload, uuid)
        .subscribe(
          async (result) => {
            resolve(result);
          },
          (error) => {
            resolve(error);
          }
        );
    });
  }

  async submitConfirmationTransfer(
    dataProfile: CustomerConfirmationTransferPayloadDTO
  ): Promise<any> {
    return new Promise(async (resolve) => {
      this.remittanceService.submitConfirmTransfer(dataProfile).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getBranchrekening(param: any): Promise<CommonResponseDTO> {
    return new Promise(async (resolve) => {
      this.branchManagementServices.getBranchrekening(param).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getImageConfirmationTransfer(uuid: string): Promise<any> {
    return new Promise(async (resolve) => {
      this.remittanceService.getImageConfirmationTransfer(uuid).subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getTransactionStatus(): Promise<any> {
    return new Promise(async (resolve) => {
      this.remittanceService.getTransactionStatus().subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  getPayToData(): PayToDataDTO[] {
    const payToData: PayToDataDTO[] = [
      {
        optionId: 'CASHATCOUNTER',
        optionTitle: 'Cash To Counter',
        optionDescription:
          'Pay in cash to designated payment counters.',
      },
      {
        optionId: 'BANKTRANSFER',
        optionTitle: 'Bank Transfer/ Cash Deposit',
        optionDescription:
          'Bank Transfer online or use Cash Deposit Machine to deposit to account for payment.',
      },
    ];
    return payToData;
  }

  async getCountries(): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataRegionServices.getCountriesSelectOption(null).subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getProvinces(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataRegionServices.getProvincesSelectOption(param).subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getCities(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.masterDataRegionServices.getCitiesSelectOption(param).subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }

  async getDataMinimumRate(param: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.dataCustomerService.getDataMinimumRate(param).subscribe(
        (result) => {
          resolve(result.data);
        },
        (error) => {
          resolve(null);
        }
      );
    });
  }
}
